<script>
  import PageHero from '$lib/page/Hero.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';
  import Links from '$lib/services/links/Index.svelte';
  import QuoteSlider from '$lib/services/QuoteSlider.svelte';
  import SolutionsSlider from '$lib/services/solutions/Slider.svelte';
  import FundingBlue from '$lib/singleService/Funding.svelte';
  import FundingWhite from '$lib/services/Funding.svelte';

  export let page_hero;
  export let links;
  export let quotes;
  export let solutions;
  export let funding;
  export let seo;
  export let faq;
</script>

<PageHero hero={page_hero} />
{#if links}
  <Links {links} />
{/if}
{#if quotes}
  <QuoteSlider {quotes} />
{/if}
{#if solutions}
  <SolutionsSlider {solutions} />
{/if}
{#if funding}
  {#if funding.type === 'blue'}
    <FundingBlue {funding} contact={funding.contact} />
  {/if}
  {#if funding.type === 'white'}
    <FundingWhite {funding} contact={funding.contact} />
  {/if}
{/if}
{#if seo}
  <Seo {seo} />
{/if}
{#if faq}
  <Faq {faq} />
{/if}
